import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { useThemeMode } from "../../ThemeContext";
import { APP_URLS } from "../../helpers/url_helper";

// Import assets for ComplianceInfo section
import DocHub from "../../assets/feature-doc-hub.svg";
import WhsAssistant from "../../assets/feature-whs-assistant.svg";
import Alerts from "../../assets/feature-alerts.svg";
import RoleAccess from "../../assets/feature-role-access.svg";
import TaskManager from "../../assets/feature-task-manager.svg";

function ComplianceInfo() {
  const { mode } = useThemeMode();

  return (
    <>
      {/* Features Section (Why Choose Us) */}
      <section className="py-5 why-trust-section" id="about">
        <Container className="text-center">
          <h2 className="why-trust-title">
            Why Australian Businesses Use Complimate for WHS & Compliance
          </h2>

          <div className="why-trust-subtitle mx-auto">
            Complimate brings your{" "}
            <Link
              to={APP_URLS.SAFETY_MANAGEMENT_SOFTWARE}
              className="section-description-link"
            >
              safety management
            </Link>{" "}
            and compliance workflows together, helping businesses manage audits,
            documents and corrective actions from one platform.
          </div>
          <Row className="justify-content-center gy-4">
            <Col xs={12} md={4}>
              <div className="why-trust-card h-100">
                <div className="why-trust-icon-box">
                  <img
                    src={DocHub}
                    className="why-trust-icon img-fluid"
                    alt="Clause-Cited Audits"
                  />
                </div>
                <div className="why-trust-card-title">Clause-Cited Audits</div>
                <div className="why-trust-card-desc">
                  Instantly map findings to WHS Act, WHS Regulation, ISO, and
                  Government standards.
                </div>
              </div>
            </Col>
            <Col xs={12} md={4}>
              <div className="why-trust-card h-100">
                <div className="why-trust-icon-box">
                  <img
                    src={WhsAssistant}
                    className="why-trust-icon img-fluid"
                    alt="Policy & Procedure Builder"
                  />
                </div>
                <div className="why-trust-card-title">
                  Policy & Procedure Builder
                </div>
                <div className="why-trust-card-desc">
                  Draft policies, procedures, and required documents in minutes
                  ready to edit and use.
                </div>
              </div>
            </Col>
            <Col xs={12} md={4}>
              <div className="why-trust-card h-100">
                <div className="why-trust-icon-box">
                  <img
                    src={Alerts}
                    className="why-trust-icon img-fluid"
                    alt="Audit Inspector"
                  />
                </div>
                <div className="why-trust-card-title">
                  Photo Audit Inspector
                </div>
                <div className="why-trust-card-desc">
                  Upload site photos and let Complimate flag hazards, attach
                  evidence, and track actions.
                </div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center gy-4 mt-2">
            <Col xs={12} md={4}>
              <div className="why-trust-card h-100">
                <div className="why-trust-icon-box">
                  <img
                    src={RoleAccess}
                    className="why-trust-icon img-fluid"
                    alt="Corrective Action Register"
                  />
                </div>
                <div className="why-trust-card-title">
                  Corrective Action Register
                </div>
                <div className="why-trust-card-desc">
                  Assign, track, and close compliance gaps with deadlines and
                  responsibility built in.
                </div>
              </div>
            </Col>
            <Col xs={12} md={4}>
              <div className="why-trust-card h-100">
                <div className="why-trust-icon-box">
                  <img
                    src={TaskManager}
                    className="why-trust-icon img-fluid"
                    alt="AI Compliance Assistant"
                  />
                </div>
                <div className="why-trust-card-title">
                  AI Compliance Assistant
                </div>
                <div className="why-trust-card-desc">
                  Ask any compliance question and get answers pulled directly
                  from your uploaded documents in seconds.
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default ComplianceInfo;
